<template>
  <b-modal
    centered
    size="md"
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container fluid>
      <b-row>
        <b-col>
          <h4 class="text-info m-2">{{ $t("globals.orders_export") }}:</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <ulu-date-picker
            range
            class="mt-3"
            v-model="dateRange"
            lang="en"
            format="DD.MM.YYYY"
            :placeholder="$t('globals.select_range')"
          />
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-btn
            style="float: right; margin: 0.3em;"
            @click="downloadCsv"
            variant="success"
            :disabled="dateRange == null"
          >
            {{ $t("globals.save") }}
          </b-btn>
          <b-btn
            style="float: left; margin: 0.3em;"
            @click="close()"
            variant="warning"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
      <a
        href=""
        id="csvdownloadlink"
        ref="csvfiledownload"
        hidden="true"
        download=""
      ></a>
    </b-container>
  </b-modal>
</template>

<script>
import axios from "axios";
import { mapGetters, mapMutations } from "vuex";

export default {
  components: {
    "ulu-date-picker": () => import("vue2-datepicker")
  },
  props: {
    show: Boolean,
    close: Function
  },
  data() {
    return {
      dateRange: null
    };
  },
  methods: {
    ...mapMutations(["setShowLoadingModal"]),
    downloadCsv() {
      this.setShowLoadingModal(true);

      let from = this.dateRange[0];
      let to = this.dateRange[1];

      from = `${from.getFullYear()}.${from.getMonth() + 1}.${from.getDate()}`;
      to = `${to.getFullYear()}.${to.getMonth() + 1}.${to.getDate()}`;

      let data = {
        query: `query {
          ordersCsv (
            date_from: "${from}",
            date_to: "${to}"
          )
        }`
      };

      axios
        .post(this.getGraphQlUrl, data, this.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            alert(res.data.errors[0].message);
            console.log(res.data.errors);
          } else {
            this.startDownloadCSV(res.data.data.ordersCsv);
          }
        })
        .catch(err => {
          alert(err);
        })
        .then(() => {
          this.setShowLoadingModal(false);
        });
    },
    startDownloadCSV(csv) {
      let d = new Date();
      let d_string = `${d.getUTCFullYear()}-`;
      d_string += `${("0" + (d.getUTCMonth() + 1)).slice(-2)}-`;
      d_string += `${("0" + d.getUTCDate()).slice(-2)}`;

      let from = this.dateRange[0];
      let to = this.dateRange[1];

      from = `${from.getFullYear()}.${from.getMonth() + 1}.${from.getDate()}`;
      to = `${to.getFullYear()}.${to.getMonth() + 1}.${to.getDate()}`;

      let link = document.getElementById("csvdownloadlink");
      link.href = "data:Application/octet-stream," + encodeURIComponent(csv);
      link.style.display = "block";
      link.download = `Orders_${this.getUserSystem}_export_range_${from}-${to}_on_${d_string}.csv`;
      link.click();
    }
  },
  computed: {
    ...mapGetters(["getDefConf", "getGraphQlUrl", "getUserSystem"])
  }
};
</script>
